import React from 'react'
import * as SurveyJS from 'survey-react'

import FileUploadWrapper from './fileUploadWrapper'

const FILE_UPLOAD_QUESTIONS = Object.freeze([
  'Xplor_ChildCourtOrders',
  'Xplor_ChildHealthRecord',
  'Xplor_ChildImmunisedRecord',
  'Xplor_ChildAnaphylaxisPlan',
  'Xplor_ChildAsthma',
  'Xplor_ChildBirthCert',
  'Xplor_ChildChildPhoto',
  'Xplor_PCPhoto',
  'Xplor_ACPhoto',
  'Xplor_ChildParentingOrders',
  'Xplor_ChildAllergyActionPlan',
  'Xplor_ChildBehaviourManagementPlan',
  'Xplor_ChildInterventionOrder',
])

const FileUploadWidget = {
  name: 'fileuploadwidget',
  title: 'fileuploadwidget',
  iconName: 'icon-default',
  widgetisLoaded: function() {
    return true
  },
  isFit: function(question) {
    return FILE_UPLOAD_QUESTIONS.includes(question.name)
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('fileuploadwidget', [], null, 'text')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <FileUploadWrapper question={question} />
  }
}

export default FileUploadWidget
